<template>
  <div class="kontrollersComp">
    <kontrollers-filters-comp v-show="showFilters" :showSliders="showFilters"/>
    <tbl-comp
        v-show="!showFilters"
        :model="this.$store.getters[`${this.moduleName}/getModel`]"
        :paging="true"
        :rowClick="rowClick"
        :moduleName="moduleName"
        :searchInput="true"
        :filters="role == 'admin'"
        :params="role == 'admin' ? filters : {}"
        :searchPlaceholder="'ID кресла'"
    />
  </div>
</template>

<script>
export default {
  name: 'kontrollersComp',
  props: {},
  data: function () {
    return {
      moduleName: 'kontrollers',
      required: ['KID', 'rating', 'BASUM', 'BAPP', 'USSD', 'GSMSL', 'k1t', 'POINT_REGION', 'POINT_OBLAST', 'POINT_GOROD', 'POINT_NAME', 'POINT_INF_TYPE']
    }
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getFilters`, {})
    this.$store.dispatch(`${this.moduleName}/setModelRequired`, { required: this.required })
  },
  components: {},
  computed: {
    role: function () {
      return localStorage.getItem('role')
    },
    filters: function () {
      return this.$store.getters[`${this.moduleName}/getFiltersQuery`]
    },
    showFilters: function () {
      return this.$store.getters[`${this.moduleName}/getShowFilters`]
    }
  },
  methods: {
    rowClick (row) {
      this.$store.dispatch(`${this.moduleName}/toUpdate`, { id: row.KID })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
